@charset "UTF-8";

/* src/app/forms/produtos/produtos.component.scss */
.block {
  animation: 0.5s fadeIn;
  animation-fill-mode: forwards;
  opacity: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.subtitle {
  width: 100%;
  font-size: var(--tem-fs-md);
  font-weight: 400;
  color: var(--tem-muted);
}
.view-component-title {
  display: flex;
  align-items: center;
  gap: var(--tem-space-2);
  padding: var(--tem-space-2) var(--tem-space-3);
  background: var(--tem-surface-2);
  border-bottom: 1px solid var(--tem-border);
}
.title {
  font-size: var(--tem-fs-lg);
  font-weight: 600;
  color: var(--tem-ink);
}
.view-component {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--tem-surface);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  overflow: hidden;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
}
.mktplace {
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.gridclass {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.mat-tab-body-content {
  height: auto !important;
}
.tabcontent {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.cardcontent {
  height: 25%;
}
.mat-mdc-tab-group {
  height: 100%;
}
:host ::ng-deep .custom-tabs {
}
:host ::ng-deep .custom-tabs .mat-tab-body-wrapper {
  height: 100%;
}
.transformimage {
  transform: scale(1.5);
}
.transformimage2 {
  transform: scale(2);
}
.transformimage3 {
  transform: scale(3);
}
.data-imagem {
  display: flex;
  flex-direction: row;
  padding-left: 20px;
  transform: scale(1.5);
}
.data-image-container {
  margin-right: var(--tem-space-2);
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
/*# sourceMappingURL=produtos.component.css.map */
